import { Button, Flex, Steps } from "antd";
import "./styles.css";

export const StepForm = (props) => {
  const {
    steps,
    currentStep,
    setCurrentStep,
    content,
    onFinish,
    form,
    onNext,
  } = props;

  const next = async () => {
    try {
      await form.validateFields();
      if (onNext) onNext(form.getFieldsValue(true));
      setCurrentStep(currentStep + 1);
    } catch (error) {}
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  return (
    <Flex vertical className="step-form" align="center" justify="center">
      <Steps
        size="small"
        current={currentStep}
        items={items}
        labelPlacement="vertical"
        style={{
          marginTop: "2rem",
        }}
        responsive={false}
        direction="horizontal"
        className="w-[85%] md:w-[80%]"
      />
      <div className="step-form-content">{content}</div>
      <div className="step-form-actions">
        {
          <Button
            className="step-form-button step-form-button-secondary"
            style={{ visibility: currentStep > 0 ? "visible" : "hidden" }}
            onClick={() => prev()}
          >
            Back
          </Button>
        }
        {currentStep < steps.length - 1 && (
          <Button
            type="primary"
            onClick={() => next()}
            className="step-form-button step-form-button-primary"
          >
            Next
          </Button>
        )}
        {currentStep === steps.length - 1 && (
          <Button
            type="primary"
            onClick={onFinish}
            className="step-form-button step-form-button-primary"
          >
            Done
          </Button>
        )}
      </div>
    </Flex>
  );
};
